var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        visible: _vm.open,
        centered: "",
        lazy: "",
        "dialog-class": "language-modal__dialog",
        "content-class": "language-modal__content",
        "header-class": "language-modal__header",
        "body-class": "language-modal__body",
        "footer-class": "language-modal__footer",
      },
      on: {
        show: _vm.resetSelection,
        change: function ($event) {
          return _vm.$emit("update:open", $event)
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c("h2", { staticClass: "language-modal__title" }, [
                _vm._v(_vm._s(_vm.$t("configuracoesidioma"))),
              ]),
              _c(
                "button",
                {
                  staticClass: "language-modal__close",
                  attrs: { type: "button", "aria-label": _vm.$t("fechar") },
                  on: {
                    click: function ($event) {
                      return close()
                    },
                  },
                },
                [
                  _c("lucide-icon", {
                    attrs: {
                      icon: _vm.closeIcon,
                      size: 20,
                      "aria-hidden": "true",
                    },
                  }),
                ],
                1
              ),
            ]
          },
        },
        {
          key: "modal-footer",
          fn: function ({ close }) {
            return [
              _c(
                "button",
                {
                  staticClass: "dm-button dm-button--secondary-outline",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return close()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "dm-button dm-button--primary",
                  attrs: { type: "button" },
                  on: { click: _vm.confirm },
                },
                [_vm._v(" " + _vm._s(_vm.$t("confirmar")) + " ")]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("div", { staticClass: "language-modal__inner" }, [
        _c("p", { staticClass: "language-modal__description" }, [
          _vm._v(" " + _vm._s(_vm.$t("selecioneidiomapreferencia")) + " "),
        ]),
        _c(
          "div",
          {
            staticClass: "language-modal__options",
            attrs: { role: "radiogroup", "aria-label": _vm.$t("idioma") },
          },
          _vm._l(_vm.options, function (option) {
            return _c(
              "label",
              {
                key: option.locale,
                staticClass: "language-option",
                class: { "is-checked": _vm.selected === option.locale },
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.$t(option.labelKey)))]),
                _c("input", {
                  staticClass: "language-option__radio",
                  attrs: { type: "radio", name: _vm.radioName },
                  domProps: {
                    value: option.locale,
                    checked: _vm.selected === option.locale,
                  },
                  on: {
                    change: function ($event) {
                      _vm.selected = option.locale
                    },
                  },
                }),
              ]
            )
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }